// extracted by mini-css-extract-plugin
export var container = "_2z-1";
export var editor = "_2z-2";
export var resizable = "_2z-3";
export var wrapper = "_2z-0";